import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const WaveCartContext = createContext(null);

export function WaveCartProvider({ children }) {
  const [selectedCreators, setSelectedCreators] = useState([]);

  const addCreator = useCallback((creator) => {
    setSelectedCreators(prev => {
      if (prev.some(c => c.id === creator.id)) return prev;
      return [...prev, creator];
    });
  }, []);

  const removeCreator = useCallback((creatorId) => {
    setSelectedCreators(prev => prev.filter(c => c.id !== creatorId));
  }, []);

  const clearCart = useCallback(() => setSelectedCreators([]), []);

  const isInCart = useCallback((creatorId) => {
    return selectedCreators.some(c => c.id === creatorId);
  }, [selectedCreators]);

  const contextValue = useMemo(() => ({
    selectedCreators,
    addCreator,
    removeCreator,
    clearCart,
    isInCart,
    count: selectedCreators.length,
  }), [selectedCreators, addCreator, removeCreator, clearCart, isInCart]);

  return (
    <WaveCartContext.Provider value={contextValue}>
      {children}
    </WaveCartContext.Provider>
  );
}

export function useWaveCart() {
  const ctx = useContext(WaveCartContext);
  if (!ctx) throw new Error('useWaveCart must be used within WaveCartProvider');
  return ctx;
}
